import {EditCondition} from "../edit-condition/editCondition";
import {CONDITION_SERVICE_NAME, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {IComponentController, ILogService, IScope} from "angular";
import {ConditionService} from "../../services/conditionService";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";

interface ConditionsListScope extends IScope {
    allConditions: any[];
    updateConditionStatus: (condition: any) => void;
    openEditModalWindow: ($event: MouseEvent, condition: any) => void;

}

export class ConditionsList implements IComponentController {

    static instance = {
        template: require('./conditionsList.html'),
        controller: ['$scope', '$log', '$mdDialog', CONDITION_SERVICE_NAME, ToastNotificationServiceName, ConditionsList],
        bindings: {
            conditions: '<'
        }
    };
    private $scope: ConditionsListScope;
    private $mdDialog: angular.material.IDialogService;
    private $log: angular.ILogService;
    private conditionService: ConditionService;
    private notificationService: ToastNotificationService;
    private conditions: any[];

    constructor($scope: ConditionsListScope,
                $log: ILogService,
                $mdDialog: angular.material.IDialogService,
                conditionService: ConditionService,
                notificationService: ToastNotificationService) {
        this.$scope = $scope;
        this.$log = $log;
        this.$mdDialog = $mdDialog;
        this.conditionService = conditionService;
        this.notificationService = notificationService;
        $scope.openEditModalWindow = this.openEditModalWindow;
        $scope.updateConditionStatus = this.updateConditionStatus;
        $log.debug('Mounting the ConditionsList component')
    }

    $onInit = () => {
        this.$scope.allConditions = this.conditions.sort((c1, c2) => c1.id - c2.id);
        this.$log.debug('Mounted the ConditionsList component');
    };

    updateConditionStatus = (condition) => {
        this.conditionService
            .updateCondition(condition)
            .then(result => {
                this.notificationService.generateSuccessMessage(`Condition ${condition.isActive ? 'activated' : 'deactivated'}!`);
            });
    };

    openEditModalWindow = ($event, condition) => {
        this.$mdDialog.show(EditCondition.getInstance($event, condition))
            .then(
                result => {
                    if (result) {
                        this.notificationService.generateSuccessMessage('Condition updated!');
                        this.replaceCondition(result);
                    }
                },
                () => {
                }
            )
    };

    replaceCondition = (condition) => {
        let allConditions = this.$scope.allConditions;
        let index = allConditions.findIndex(c => condition.id === c.id);
        allConditions[index] = condition;
    }

}